module.exports = __webpack_public_path__ + "images/klinkerhof-aa98945f3c8fc26c6ba1adfd2a8254f1.jpg";